// ** React Imports
import React from 'react'

// ** MUI Imports
import { Grid } from '@mui/material'

// ** Child Imports
import AnalyticsDataWidget from '../visualizations/AnalyticsDataWidget'

// ** Util Imports
import { WidgetType } from 'src/lib/types/dashboardAnalytics'
import { initialDiscountPerformanceData, discountPerformanceWidgetConfig } from 'src/assets/AnalyticsConfig'

const DiscountPerformanceWidget: React.FC<WidgetType> = ({ value, isLoading, isReportView = false }) => {
  const defaultValue = initialDiscountPerformanceData?.data?.widgetData
  const fontProperties = [
    {
      fontSize: 28,
      fontWeight: 600,
      fontColor: '#4D4D4D',
      lineHeight: '32px'
    },
    {
      fontSize: 20,
      fontWeight: 500,
      fontColor: '#4D4D4D',
      lineHeight: '22px'
    },
    {
      fontSize: 20,
      fontWeight: 500,
      fontColor: '#4D4D4D',
      lineHeight: '22px'
    },
    {
      fontSize: 20,
      fontWeight: 500,
      fontColor: '#4D4D4D',
      lineHeight: '22px'
    }
  ]

  return (
    <>
      <div className='flex w-full gap-3 flex-nowrap'>
        {(value ?? defaultValue)?.map((summary: any, index: number) => {
          return (
            <div
              className={`flex grow flex-col gap-2 rounded ${
                isReportView ? 'border border-gray-light' : index === 0 ? 'border border-gray-light' : ''
              } px-3 py-4 ${index === 0 && !isReportView ? 'bg-[#FAFAFA]' : 'bg-white'}`}
              key={`${index}`}
            >
              {summary?.map((pointValue: any, innerIndex: number) => {
                return (
                  <AnalyticsDataWidget
                    key={`${innerIndex}`}
                    customClass={`${index === 0 && !isReportView ? 'bg-[#FAFAFA]' : ''}`}
                    removeInnerPadding
                    widgetType={discountPerformanceWidgetConfig?.[index]?.[innerIndex]?.widgetType}
                    valueType={discountPerformanceWidgetConfig?.[index]?.[innerIndex]?.valueType}
                    description={discountPerformanceWidgetConfig?.[index]?.[innerIndex]?.description}
                    widgetWidth={'100%'}
                    fontProperties={fontProperties[innerIndex]}
                    value={pointValue?.x ?? '0'}
                    isLoading={isLoading}
                    hideBorders
                    cardVariant='outlined'
                  />
                )
              })}
            </div>
          )
        })}
      </div>
    </>
  )
}

export default DiscountPerformanceWidget
